import { CellView, Graph } from "@antv/x6"
import { Cell, EdgeOptions } from "@antv/xflow"
import { LineType } from "../constant"
import { v4 as uuidv4 } from "uuid";
import { cellToNodeState } from "../services/storage"
import { EquipmentType, NozzleDirection } from "@/types/common"
import { tagGenerator } from "../services/TagGenerator"
import { NodeShapes, SvgStreamDataState } from "../services/modal"

export interface EdgeData {
  type: LineType
}


export const onCreateEdge = (params: {
  sourceCell: Cell
  sourceView: CellView
  sourceMagnet: Element
}): EdgeOptions => {
  const {sourceCell, sourceMagnet} = params
  const id = uuidv4()
  const portId = sourceMagnet.getAttribute('port')
  const nodeState = cellToNodeState(sourceCell as any)
  const nozzles = nodeState.nozzles
  const nozzle = nozzles.find(item => item.id === portId)
  const simName = nozzle?.direction === NozzleDirection.Outlet ? 'OUT' : 'IN'
  const tag = tagGenerator.generateTag(EquipmentType.Stream);
  let streamId: string | undefined = undefined
  if (sourceCell.shape === NodeShapes.SvgStream) {
    const nodeData = sourceCell.getData() as SvgStreamDataState
    streamId = nodeData.streamId
    sourceCell.setData({...nodeData, refStreamId: id})
  }
  return {
    id, 
    data: { type: LineType.FlowLine, id, tag, simName, isNew: true, streamId },
    shape: 'edge',
    attrs: {
      line: {
        stroke: '#222',
        strokeWidth: 2,
        targetMarker: null,
      },
    },
  }
}

export const onCreateLine = (params: {
  sourceCell: Cell
  sourceView: CellView
  sourceMagnet: Element
}): EdgeOptions => {
  const id = uuidv4()
  return {
    id,
    data: { type: LineType.Line, id, isNew: true },
    shape: 'edge',
    attrs: {
      line: {
        stroke: '#222',
        strokeWidth: 2,
        targetMarker: null,
      },
    },
  }
}